import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { ToastNotification } from 'carbon-components-react';

const Toast = props => {
    const { toastList, autoDelete, autoDeleteTime } = props;
    const [list, setList] = useState(toastList);

    useEffect(() => {
        setList(toastList);
    }, [toastList, list]);

    return (
        <>
            <div className="top-right">
                {list.map((toast, i) =>
                    <ToastNotification
                        kind={toast.kind}
                        caption={toast.time}
                        iconDescription="Dismiss Notification"
                        subtitle={toast.description}
                        timeout={5000}
                        title={toast.title}
                    />
                )}
            </div>
        </>
    );
}

export default Toast;